import styles from "./Portifolio.module.css";

const benefits = [
  {
    icon: "\u{1F4BB}",
    title: "Tecnologia Moderna",
    description:
      "Desenvolvido com React e Node.js, garantindo performance, escalabilidade e uma interface moderna para sua equipe.",
  },
  {
    icon: "\u{1F91D}",
    title: "Suporte Dedicado",
    description:
      "Atendimento direto com a equipe de desenvolvimento. Sem filas, sem bots. Suporte humano e agil quando voce precisa.",
  },
  {
    icon: "\u{26A1}",
    title: "Implantacao Rapida",
    description:
      "Sistema 100% web, sem necessidade de instalacao. Configure e comece a usar em poucos dias com acompanhamento completo.",
  },
  {
    icon: "\u{1F527}",
    title: "Personalizacao",
    description:
      "Cada empresa e unica. Adaptamos modulos e funcionalidades para atender exatamente as necessidades do seu negocio.",
  },
];

export default function Portfolio() {
  return (
    <section className={styles.portfolio} id="diferenciais">
      <h2 className={styles.sectionTitle}>Por que escolher a MB Sistemas?</h2>
      <p className={styles.sectionSubtitle}>
        Mais do que software, entregamos solucoes que fazem diferenca no seu dia a dia
      </p>

      <div className={styles.grid}>
        {benefits.map((benefit, index) => (
          <div key={index} className={styles.card}>
            <span className={styles.icon}>{benefit.icon}</span>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
